/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Failed_To_Load_Translations_CountInputs */



/**
* | output |
* | --- |
* | "Failed to load {count} translation(s)" |
*
* @param {Failed_To_Load_Translations_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_load_translations_count = /** @type {((inputs: Failed_To_Load_Translations_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Load_Translations_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec du chargement de ${i?.count} traduction(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Übersetzung(en) konnten nicht geladen werden`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile caricare ${i?.count} traduzione/i`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить ${i?.count} перевод(ов)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron cargar ${i?.count} traducción(es)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`加载 ${i?.count} 个翻译失败`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count}件の翻訳を読み込めませんでした`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} अनुवाद लोड करने में विफल`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao carregar ${i?.count} tradução(ões)`)
	return /** @type {LocalizedString} */ (`Failed to load ${i?.count} translation(s)`)
});